<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-25 10:38:59
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-25 11:20:14
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\cooperativeColonel\list\components\ksTab.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-table
			v-sticky-header="{ offsetTop: 0 }"
			class="table-small"
			header-row-class-name="table-header-row"
			row-class-name="table-row"
			@sort-change="sortChange"
			:data="list"
			ref="multipleTable"
		>
			<el-table-column label="团长信息" min-width="196">
				<template slot-scope="{ row }">
					<div>
						<div class="flex-row-align-center">
							<platform-icon :platformId="row.platform_id" class="flex-shrink"></platform-icon>
							<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.institution_name">
								<p class="yx-color-text-primary font-h6-medium ml-4" style="width: 100%">{{ row.institution_name }}</p>
							</el-tooltip>
						</div>

						<p class="yx-color-text-regular font-h6-regular">
							<span>机构ID：{{ row.authority_id }}</span>
						</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="出单商品" min-width="100" sortable="custom" prop="order_anchor_num">
				<template slot-scope="{ row }">
					<p>{{ row.productPayCount | formatEmpty | formatPrice2 }}</p>
				</template>
			</el-table-column>
			<el-table-column label="出单达人" min-width="100" sortable="custom" prop="order_product_num">
				<template slot-scope="{ row }">
					<p>{{ row.anchorPayCount | formatEmpty | formatPrice2 }}</p>
				</template>
			</el-table-column>
			<el-table-column label="寄样次数" min-width="80">
				<template slot-scope="{ row }">
					<p>{{ row.productSendSampleNum | formatEmpty | formatPrice2 }}</p>
				</template>
			</el-table-column>
			<el-table-column label="寄样出单率" min-width="100">
				<template slot-scope="{ row }">
					<p>{{ row.orderRate | formatEmpty | formatPercent }}</p>
				</template>
			</el-table-column>
			<el-table-column label="销售额" min-width="120" sortable="custom" prop="sale_amount">
				<template slot-scope="{ row }">
					<p>{{ row.payOrderGmv | formatEmpty | formatPrice | formatPrice2 }}</p>
				</template>
			</el-table-column>
			<el-table-column label="预估到手服务费" min-width="120">
				<template slot-scope="{ row }">
					<p>{{ row.estimateServiceAmount | formatEmpty | formatPrice | formatPrice2 }}</p>
				</template>
			</el-table-column>
			<el-table-column label="跟进信息" min-width="120">
				<template slot-scope="{ row }">
					<div class="yx-color-text-primary font-h6-regular">
						<el-tooltip placement="top" :content="row.partner_role_name" v-ak-tooltip-auto-show>
							<p class="line-ellipsis-1" style="width: 100%">{{ row.partner_role_name }}</p>
						</el-tooltip>
						<p>{{ row.add_time }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" prop="operates" min-width="100" align="right">
				<template slot-scope="{ row }">
					<el-button v-if="$auth.hasPermi('system:cooperativeColonel-detail:query')" type="text" @click="goToDetail(row)">查看详情</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
export default {
	components: {},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {};
	},
	methods: {
		goToDetail({ team_institution_id, platform_id }) {
			this.$router.push({
				path: '/secondColonelManage/cooperativeColonel/detail',
				query: { id: team_institution_id, platformId: platform_id },
			});
		},
		sortChange({ prop, order }) {
			let keys = order === 'ascending' ? prop + '_asc' : order === 'descending' ? prop + '_desc' : '';
			this.$emit('refresh', keys);
		},
	},
};
</script>
<style lang="less" scoped>
::v-deep .el-button--small {
	font-size: 12px;
}
/deep/ .el-table__fixed {
	box-shadow: 8px 3px 7px rgba(0, 0, 0, 0.08);
}
/deep/ .el-table__fixed-right {
	box-shadow: -3px 3px 3px rgba(0, 0, 0, 0.08);
}
</style>